export enum TwentyOneAssetType {
  StartButton = 'start_button',
  PlayIcon = 'play_icon',
  CardBack = 'card_back',
  CardShadow = 'card_shadow',
  CardClub = 'card_club',
  CardDiamond = 'card_diamond',
  CardHeart = 'card_heart',
  CardSpade = 'card_spade',
  CardWild = 'card_wild',
  ScoreBox = 'score_box',
  ColumnBox = 'column_box',
  ColumnBoxFill = 'column_box_fill',
  Chevron = 'chevron',
  WildSparkle = 'sparkle_solid',
}

export enum TwentyOneSpriteType {
  NumbersLargePink = 'numbers_large_pink',
  NumbersLargeBlack = 'numbers_large_black',
  NumbersSmallPink = 'numbers_small_pink',
  NumbersSmallBlack = 'numbers_small_black',
}

export enum TwentyOneTranslationsType {
  Play = 'play', // Play
}

export enum TwentyOneStylesType {
  BackgroundPrimary = '--background-fill',
  ButtonPrimaryLabel = '--button-action-primary-label-fill',
  BonusLabelFill = '--game-twentyone-bonus-label-fill',
  BonusLabelOutline = '--game-twentyone-bonus-label-outline',
  WildSymbolColor = '--game-twentyone-wild-symbol-fill',
  ScoreLabelFill = '--game-twentyone-score-fill',
  HintLabelFill = '--game-twentyone-hint-fill',
  DeckLabelFill = '--game-twentyone-pill-label-fill',
  DeckBoxColor = '--game-twentyone-pill-background-fill',
}
